export const generateDonutOptions = (labels) => ({
  chart: {
    type: "donut",
  },
  responsive: [
    {
      breakpoint: 480,
      options: {
        chart: {
          width: "100%",
        },
      },
    },
  ],
  width: "100%",
  legend: {
    position: "bottom",
  },
  labels,
});
